var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    'icon-wrapper': true,
    'icon-wrapper-img': !_vm.fromMap
  }},[(!_vm.fromMap)?[_c('img',{class:_vm.iconClass,attrs:{"alt":'Icon ' + _vm.name,"src":require('@/assets/images/icons/' + _vm.name + '.png')}})]:[_c('svg',{class:_vm.iconClass},[_c('use',{attrs:{"xlink:href":require('@/assets/images/svg/svg-map.svg') + '#' + _vm.name}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }